import { Component, OnInit, Input } from '@angular/core';
import {
  type FlightJourney,
  WithSubscriptionComponent,
  type FlightItinerary,
  EnterpriseSearchService,
  ServiceType
} from '@sabstravtech/obtservices/angular';
import {
  Memorise,
  FlightEquipment,
  getTimeDifference,
  dayDifference,
  sanitiseDateTime
} from '@sabstravtech/obtservices/base';
import moment from 'moment';

@Component({
  selector: 'app-flight-legs',
  templateUrl: './flight-legs.component.html',
  styleUrls: ['./flight-legs.component.scss'],
  standalone: false
})
export class FlightLegsComponent extends WithSubscriptionComponent implements OnInit {
  @Input() legs!: FlightJourney[];
  @Input() altColour!: boolean;
  @Input() flight!: FlightItinerary;
  @Input() isReturn = false;
  @Input() isMultiCity = false;
  @Input() flightIndex: number;
  timeDifference = 0;

  // enums
  FlightEquipment: typeof FlightEquipment = FlightEquipment;

  constructor(public searchService: EnterpriseSearchService) {
    super();
  }

  ngOnInit(): void {}

  showTimeDifference(depDateTime: string, arrDateTime: string): boolean {
    this.timeDifference = getTimeDifference(arrDateTime, depDateTime);
    return this.isMultiCity ? !!(this.timeDifference < 1440) : true;
  }

  @Memorise()
  setIco(leg: FlightJourney): string {
    if (leg.equipmentCode === 'BUS') {
      return 'ico-bus';
    } else {
      return 'ico-flight';
    }
  }

  calculateDayDifference(dept: string, arr: string): string {
    const diff = dayDifference(sanitiseDateTime(dept), sanitiseDateTime(arr));
    return diff ? '+' + diff : '';
  }

  parseDateToMoment(dateString: string): moment.Moment {
    return moment(sanitiseDateTime(dateString));
  }
}
